import {
  Action,
  Module,
  Mutation,
  VuexModule,
} from "vuex-module-decorators";
import store from "../store";

/**
 * 🧩 Module which handles the user's preferences on the platform
 */
@Module
export default class UserPreferencesModule extends VuexModule {
  // 🚩 Flag for whether sensitive data should be shown or not
  public censorSensitiveData: boolean = false;

  // 🚩 Flag for whether the app is shown in dark mode
  public darkMode: boolean = false;

  // 🚩 Flag for whether the coin amount for each cryptocurrency is shown in the dashboard's donut chart
  public showDashboardCoinAmount: boolean = true;

  // 🚩 Flag for whether a detailed version of the dashboard's donut chart should be shown
  public showDetailedDashboardDonutChart: boolean = false;

  // 🚩 Flag for whether the app is shown in dark mode
  public liteMode: boolean | undefined = undefined;

  public selectedDashboardTimeFrame: number | null = null;

  /**
   * 👾 Mutation for changing the state for the censoring of sensitive data
   * @param censor
   */
  @Mutation
  public SET_SENSITIVE_DATA_CENSORSHIP(censor: boolean) {
    this.censorSensitiveData = censor;
  }

  /**
   * 🔨 Action that changes the state for the censoring of sensitive data
   * @param censor
   */
  @Action
  public async changeSensitiveDataCensorship(censor: boolean) {
    this.context.commit("SET_SENSITIVE_DATA_CENSORSHIP", censor);
  }

  @Mutation
  public SET_THEME_MODE(darkMode: boolean) {
    this.darkMode = darkMode;
  }

  /**
   * 🔨 Action that changes the state for the censoring of sensitive data
   * @param censor
   */
  @Action
  public async changeThemeMode(darkMode: boolean) {
    this.context.commit("SET_THEME_MODE", darkMode);
  }

  @Mutation
  public SET_CHANGE_DASHBOARD_COIN_AMOUNT_VISIBILITY(showCoinAmount: boolean) {
    this.showDashboardCoinAmount = showCoinAmount;
  }

  /**
   * 🔨 Action that changes the flag for whether the token amounts should be shown on the dashboard donut chart
   * @param showCoinAmount
   */
  @Action
  public async changeDashboardCoinAmountVisibility(showCoinAmount: boolean) {
    this.context.commit("SET_CHANGE_DASHBOARD_COIN_AMOUNT_VISIBILITY", showCoinAmount);
  }

  @Mutation
  public SET_SHOW_DETAILED_DASHBOARD_DONUT_CHART(showDetailedChart: boolean) {
    this.showDetailedDashboardDonutChart = showDetailedChart;
  }

  /**
   * 🔨 Action that changes the flag for whether the token amounts should be shown on the dashboard donut chart
   * @param showCoinAmount
   */
  @Action
  public async changeDetailedDashboardDonutChart(showDetailedChart: boolean) {
    this.context.commit("SET_SHOW_DETAILED_DASHBOARD_DONUT_CHART", showDetailedChart)
  }

  /**
   * 👾 Mutation for changing the user's creation time
   * @param isUserEmailVerified
   */
  @Mutation
  public SET_APP_VIEW_MODE(liteMode: boolean) {
    this.liteMode = liteMode;
  }

  /**
   * 🔨 Action that sets whether the lite or advanced mode of the app should be shown to the user
   * @param liteMode
   */
  @Action
  public async changeAppViewMode(liteMode: boolean) {
    this.context.commit("SET_APP_VIEW_MODE", liteMode);
  }

  /**
   * 👾 Mutation that changes the currently selected dashboard time frame
   * @param newTimeFrame
   */
  @Mutation
  public SET_DASHBOARD_TIME_FRAME(newTimeFrame: number | null) {
    this.selectedDashboardTimeFrame = newTimeFrame;
  }

  /**
   * 🔨 Action that sets whether the lite or advanced mode of the app should be shown to the user
   * @param newTimeFrame
   */
  @Action
  public async changeDashboardTimeFrame(selectedTimeFrame: number | null) {
    this.context.commit("SET_DASHBOARD_TIME_FRAME", selectedTimeFrame);
    store.dispatch("changeAppBarLoading", true);
    await store.dispatch("fetchTradingBotStats");
    store.dispatch("changeAppBarLoading", false);
  }
}
